/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagLabelSchema
 */
export interface TagLabelSchema {
    /**
     * 
     * @type {string}
     * @memberof TagLabelSchema
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof TagLabelSchema
     */
    systemTag: boolean;
}

/**
 * Check if a given object implements the TagLabelSchema interface.
 */
export function instanceOfTagLabelSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "systemTag" in value;

    return isInstance;
}

export function TagLabelSchemaFromJSON(json: any): TagLabelSchema {
    return TagLabelSchemaFromJSONTyped(json, false);
}

export function TagLabelSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagLabelSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'systemTag': json['system_tag'],
    };
}

export function TagLabelSchemaToJSON(value?: TagLabelSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'system_tag': value.systemTag,
    };
}

